(function () {
var section = document.querySelector('.build-bundle-section');
if (!section || section.dataset.byobInit === '1') return;
section.dataset.byobInit = '1';
var tierWrap = section.querySelector('[data-byob-tiers]');
var button = section.querySelector('[data-byob-start]');
var embed = section.querySelector('[data-byob-embed]');
var stage = section.querySelector('[data-byob-stage]');
var inner = section.querySelector('[data-byob-inner]');
var veil = section.querySelector('[data-byob-veil]');
var closeBtn = section.querySelector('[data-byob-close]');
var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
var pending = null;
var retries = 2;
var mounted = false;
var open = false;
var spotlight = null;
var engaged = false;
section.classList.add('is-ready');
if (reduceMotion) {
section.classList.add('is-visible');
prepare();
} else {
var observer = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (!entry.isIntersecting) return;
section.classList.add('is-visible');
startSpotlight();
prepare();
observer.unobserve(section);
});
}, { threshold: 0.22, rootMargin: '300px 0px' });
observer.observe(section);
}
function noticed() {
stopSpotlight();
}
function engage() {
if (engaged) return;
engaged = true;
stopSpotlight();
section.classList.add('is-engaged');
}
function stopSpotlight() {
if (spotlight) {
clearInterval(spotlight);
spotlight = null;
}
section.querySelectorAll('.build-bundle-card.is-hot').forEach(function (card) {
card.classList.remove('is-hot');
});
}
function startSpotlight() {
if (engaged || reduceMotion || spotlight) return;
var step = -1;
spotlight = setInterval(function () {
var cards = section.querySelectorAll('.build-bundle-card');
if (!cards.length) return;
cards.forEach(function (card) { card.classList.remove('is-hot'); });
step += 1;
if (step >= cards.length + 1) step = 0;
if (step < cards.length) cards[step].classList.add('is-hot');
}, 1150);
}
function wireCards() {
section.querySelectorAll('[data-byob-card]').forEach(function (card) {
card.addEventListener('click', reveal);
card.addEventListener('pointerenter', noticed);
card.addEventListener('pointerenter', invite);
card.addEventListener('pointerleave', uninvite);
if (!finePointer || reduceMotion) return;
card.addEventListener('pointermove', function (event) {
var rect = card.getBoundingClientRect();
var x = event.clientX - rect.left;
var y = event.clientY - rect.top;
var centerX = rect.width / 2;
var centerY = rect.height / 2;
var rotateX = ((y - centerY) / centerY) * -5;
var rotateY = ((x - centerX) / centerX) * 7;
card.style.setProperty('--mouse-x', x + 'px');
card.style.setProperty('--mouse-y', y + 'px');
card.style.transform =
'perspective(800px) translateY(-8px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) scale(1.025)';
});
card.addEventListener('pointerleave', function () {
card.style.transform = '';
card.style.setProperty('--mouse-x', '50%');
card.style.setProperty('--mouse-y', '50%');
});
});
}
function invite() {
if (open) return;
section.classList.add('is-inviting');
}
function uninvite() {
section.classList.remove('is-inviting');
}
function getOffer() {
var data = window.AVADA_BUNDLE;
if (!data) return null;
var list = data.bundleBuilderOffers || [];
if (!list.length && data.allOffers) {
list = data.allOffers.filter(function (offer) {
return offer && offer.type === 'bundle-builder';
});
}
return list.filter(function (offer) {
return offer && offer.bundleBuilderProductHandle;
})[0] || null;
}
function waitForApp(timeout) {
var deadline = Date.now() + timeout;
return new Promise(function (resolve) {
(function poll() {
var offer = getOffer();
if (offer && window.AVADA_BUNDLE && typeof window.AVADA_BUNDLE.reRenderBlocks === 'function') {
resolve(offer);
return;
}
if (Date.now() > deadline) {
resolve(null);
return;
}
setTimeout(poll, 250);
})();
});
}
function builderNode() {
return section.querySelector('.Avada-Bundle-Offer__BundleBuilder');
}
function waitForRender(timeout) {
var deadline = Date.now() + timeout;
return new Promise(function (resolve) {
(function poll() {
var node = builderNode();
if (node && node.children.length) {
resolve(true);
return;
}
if (Date.now() > deadline) {
resolve(false);
return;
}
setTimeout(poll, 200);
})();
});
}
async function mountBuilder() {
var offer = getOffer() || (await waitForApp(15000));
if (!offer) return false;
showPanel();
var data = window.AVADA_BUNDLE;
var response = await fetch(window.Shopify.routes.root + 'products/' + offer.bundleBuilderProductHandle + '.js');
if (!response.ok) return false;
var product = await response.json();
data.page = 'product';
data.product = {
id: String(product.id),
handle: product.handle,
title: product.title,
variants: product.variants,
selectedVariant: product.variants[0],
collections: [],
collectionIds: [],
type: product.type,
vendor: product.vendor,
tags: product.tags,
price: product.price,
available: product.available,
featured_image: product.featured_image
};
try {
data.reRenderBlocks();
} catch (error) {
}
return waitForRender(12000);
}
function prepare() {
if (mounted) return Promise.resolve(true);
if (pending) return pending;
pending = (async function () {
var ok = false;
try {
ok = await mountBuilder();
} catch (error) {
ok = false;
}
if (ok) {
mounted = true;
showPanel();
embed.classList.add('is-loaded');
} else if (!open) {
embed.hidden = true;
embed.classList.remove('is-peeking');
}
pending = null;
if (!ok && !open && retries > 0) {
retries -= 1;
setTimeout(prepare, 2500);
}
return ok;
})();
return pending;
}
function showPanel() {
embed.hidden = false;
if (!open) embed.classList.add('is-peeking');
}
function scrollToEmbed() {
var header = document.querySelector('.section-header, header.header-wrapper, #shopify-section-header');
var offset = header ? header.getBoundingClientRect().height : 0;
var top = embed.getBoundingClientRect().top + window.pageYOffset - offset - 20;
window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
}
function expand() {
open = true;
uninvite();
engage();
embed.classList.remove('is-peeking');
embed.classList.add('is-open');
section.classList.add('is-open');
stage.style.maxHeight = inner.scrollHeight + 'px';
var release = function () {
stage.style.maxHeight = 'none';
stage.removeEventListener('transitionend', release);
};
stage.addEventListener('transitionend', release);
setTimeout(release, 800);
scrollToEmbed();
}
function collapse() {
open = false;
stage.style.maxHeight = stage.scrollHeight + 'px';
requestAnimationFrame(function () {
embed.classList.remove('is-open');
section.classList.remove('is-open');
embed.classList.add('is-peeking');
stage.style.maxHeight = '';
});
section.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
}
function fallback() {
var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var offer = getOffer();
var handle = (offer && offer.bundleBuilderProductHandle) || button.dataset.handle;
var url = button.dataset.fallback;
if (!url && handle) url = root.replace(/\/$/, '') + '/products/' + handle;
if (url) {
window.location.href = url;
return;
}
var link = button.dataset.link;
var target = (link && document.querySelector(link)) || document.querySelector('.pnp-section');
if (target) {
target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
}
}
async function reveal() {
if (open) {
scrollToEmbed();
return;
}
if (mounted) {
expand();
return;
}
button.classList.add('is-loading');
embed.hidden = false;
expand();
var ok = await prepare();
button.classList.remove('is-loading');
if (ok) {
stage.style.maxHeight = 'none';
} else {
open = false;
embed.hidden = true;
embed.classList.remove('is-open');
section.classList.remove('is-open');
fallback();
}
}
var tierWording = null;
function tierEscape(text) {
return String(text == null ? '' : text).replace(/[&<>"]/g, function (c) {
return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c];
});
}
function captureTierWording() {
if (tierWording) return tierWording;
var label = 'ANY {n} PRODUCTS';
var off = 'OFF';
var sample = tierWrap && tierWrap.querySelector('.build-bundle-label');
if (sample && (sample.textContent || '').trim()) {
var pattern = sample.textContent.trim().replace(/\d+(\s*\+)?/, '{n}');
if (pattern.indexOf('{n}') >= 0) label = pattern;
}
var offEl = tierWrap
&& tierWrap.querySelector('.build-bundle-percent span + span');
if (offEl && (offEl.textContent || '').trim()) {
off = offEl.textContent.trim();
}
var arrow = tierWrap && tierWrap.querySelector('.build-bundle-go');
tierWording = {label: label, off: off, arrow: arrow ? arrow.outerHTML : ''};
return tierWording;
}
function renderTiers(offer) {
if (!tierWrap || !offer) return;
var wording = captureTierWording();
var tiers = (offer.discountOptions || [])
.slice()
.sort(function (a, b) {
return Number(a.quantity) - Number(b.quantity);
});
if (tiers.length < 2) return;
var percent = offer.discountType !== 'fixed-amount';
tierWrap.innerHTML = tiers
.slice(0, 3)
.map(function (tier, index, list) {
var last = index === list.length - 1;
var qty = Number(tier.quantity) || 0;
var value = Number(tier.discountValue) || 0;
return (
'<button type="button" class="build-bundle-card" data-byob-card>' +
'<span class="build-bundle-shine"></span>' +
'<span class="build-bundle-value">' +
'<span class="build-bundle-number">' + value + '</span>' +
'<span class="build-bundle-percent">' +
'<span>' + (percent ? '%' : '&euro;') + '</span>' +
'<span>' + tierEscape(wording.off) + '</span>' +
'</span>' +
'</span>' +
'<span class="build-bundle-label">' + tierEscape(wording.label.replace('{n}', qty + (last ? '+' : ''))) + '</span>' +
wording.arrow +
'</button>'
);
})
.join('');
wireCards();
}
wireCards();
waitForApp(6000).then(function (offer) {
if (offer) renderTiers(offer);
});
if (veil) veil.addEventListener('click', reveal);
if (closeBtn) closeBtn.addEventListener('click', collapse);
if (button) {
button.addEventListener('click', reveal);
button.addEventListener('pointerenter', noticed);
button.addEventListener('pointerenter', invite);
button.addEventListener('pointerleave', uninvite);
}
})();